import React from "react";
import { Link } from "react-router-dom";
import service1 from "../../assets/images/service1.png";
import service2 from "../../assets/images/service2.png";
import service3 from "../../assets/images/service3.png";

const servicesData = [
  {
    icon: "icofont-robot-face",
    title: "Coach IA personnel",
    subtitle: "Ton accompagnement 100% personnalisé",
    description:
      "Un coach IA disponible 24h/24 pour t’aider à mieux te connaître, poser tes objectifs et avancer pas à pas selon ton profil.",
    features: [
      "Conversations personnalisées",
      "Conseils adaptés à ton parcours",
    ],
    imageSrc: service1,
  },
  {
    icon: "icofont-brain-alt",
    title: "Tests & Profiling avancé",
    subtitle: "Comprends-toi en quelques minutes",
    description:
      "Des mini-tests rapides et fun pour révéler ta personnalité, tes forces, tes centres d’intérêt et ton style d’apprentissage.",
    features: [
      "Résultats immédiats",
      "Insights clairs sur ton profil",
      "Adapté pour la Génération Z",
    ],
    imageSrc: service2,
  },
  {
    icon: "icofont-ui-search",
    title: "Recommandations personnalisées",
    subtitle: "Explore les meilleures pistes pour toi",
    description:
      "Formations, métiers et opportunités recommandés selon ton potentiel, ton profil et ton évolution dans l’application.",
    features: [
      "Suggestions ultra personnalisées",
      "Mises à jour en continu",
      "Aligné avec ton profil et tes objectifs",
    ],
    imageSrc: service3,
  },
];

function Service() {
  return (
    <section id="features" className="row_am service_section">
      <div className="container">
        <div
          className="section_title"
          data-aos="fade-up"
          data-aos-duration={1500}
        >
          <span className="title_badge mb-1">Ton évolution commence ici</span>
          <h2>
            Découvre ce que <span>Neoori</span> peut
            <br />
            faire pour toi
          </h2>
        </div>
        {servicesData.map((service, index) => (
          <div
            className={`row service_blocks ${
              index % 2 === 0 ? "" : "flex-row-reverse"
            }`}
            key={index}
          >
            <div className="col-md-6">
              <div
                className={`service_text ${
                  index % 2 === 0 ? "" : "right_side"
                }`}
                data-aos="fade-up"
                data-aos-duration={1500}
              >
                <div className="service_badge">
                  <i className={service.icon} />
                  <span>{service.title}</span>
                </div>
                <h2>
                  <span>{service.subtitle}</span>
                </h2>
                <p>{service.description}</p>
                <ul
                  className={`${
                    index % 2 === 0 ? "listing_block" : "feature_list"
                  }`}
                >
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex}>
                      <div className="icon">
                        <span>
                          <i className="icofont-ui-check" />
                        </span>
                      </div>
                      <div className="text">
                        <h3>{feature}</h3>
                      </div>
                    </li>
                  ))}
                </ul>
                <div className="btn_block">
                  <Link to="/contact" className="btn puprple_btn ml-0">
                    Commencer mon parcours
                  </Link>
                  <div className="btn_bottom" />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="img" data-aos="fade-up" data-aos-duration={1500}>
                <img src={service.imageSrc} alt="" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Service;
